import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobsService } from 'src/app/collaboration/components/jobs/components/services/jobs.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { SharedService } from 'src/app/shared/services/shared.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { LayoutService } from '../../services/layout.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { formMode } from 'src/app/shared/enums';
import { StorageService } from 'src/app/shared/services/storage.service';
import { collaborationDdlService } from 'src/app/collaboration/components/jobs/components/services/ddl.service';
import { costddls, jobCostRequestModel, jobCostResponseModel, jobsStaffDdlResponseModel, userprofileDdlResponseModel } from 'src/app/collaboration/components/jobs/components/models/jobs';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { DdlService } from 'src/app/interactions/services/ddl.service';
import { clientDdlResponseModel } from 'src/app/interactions/models/clients';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { costResponseModel, costTypeResponseModel } from 'src/app/organization/models/costs';
import { ExpensesService } from 'src/app/organization/services/expenses.service';
import { catchError, Observable, of, tap } from 'rxjs';
import { ddlService } from 'src/app/organization/services/ddl.service';
import { Router } from '@angular/router';
import { ConfirmService } from 'src/app/shared/services/confirm.service';

@Component({
  selector: 'app-job-expense',
  templateUrl: './job-expense.component.html',
})
export class JobExpenseComponent extends BaseComponent implements OnInit {
  @Input() triggerApi!: boolean;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  jobs_expense_form: FormGroup | any;
  job_cost_request: jobCostRequestModel;

  label: boolean = true;
  error_message: any
  selectedStartDate: any;

  user_list: any = [];
  jobs_list: any;
  job_task_list: any;
  client_list: any;
  cost_list: any;
  cost_type_list: any;
  url: any
  job_id: string;
  job_name: string;
  form_mode = formMode.Create;
  job_cost_id: any;
  client_id: any;
  client_name: any
  current_page = this.storage_service.getPage();
  items_per_page = this.storage_service.getLimit();
  cost_details: any
  quotes_accepted_cost: boolean = false;
  public isFormDirty: boolean = false

  constructor(
    public shared_service: SharedService,
    public jobs_service: JobsService,
    public layoutService: LayoutService,
    public translate_service: TranslationService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private storage_service: StorageService,
    private collaborationddl_service: collaborationDdlService,
    private fb: FormBuilder,
    private router: Router,
    private toaster_service: ToasterService,
    private ddl_service: DdlService,
    private org_ddl_service: ddlService,
    private spinner_service: SpinnerService,
    private expense_service: ExpensesService,
    private confirm_service: ConfirmService
  ) {
    super();
    this.selectedStartDate = new Date();
    if (this.config.data) {
      this.label = this.config.data.label
      this.job_id = this.config.data.job_id
      this.form_mode = this.config.data.form_mode
      this.job_cost_id = this.config.data.cost_id
      this.client_id = this.config.data.client_id
      this.client_name = this.config.data.client_name
      this.url = this.config.data.url
    }
  }

  ngOnInit(): void {
    this.jobs_expense_form = this.fb.group({
      client_id: [null, Validators.required],
      staff_id: [null, Validators.required],
      job_id: [null, Validators.required],
      unit_cost: ['', Validators.required],
      unit_price: ['', Validators.required],
      quantity: ['1', Validators.required],
      cost_id: [null, Validators.required],
      date: [this.selectedStartDate],
      description: [''],
      is_billable: [true],
      code: [''],
      is_actual: [false],
      cost_sell_type_id: [null, Validators.required]
    });

    this.shared_service.accountSettings$.subscribe(value => {
      const quotes_accepted_cost = value?.quote_accepted_cost_id !== 1;
      this.jobs_expense_form.patchValue({
        is_actual: quotes_accepted_cost
      });
    });

    this.loadcostlist();
    this.loadstaff_Ddl();
    this.loadClients();
    this.loadCostType();


    if (!this.label) {
      this.jobs_expense_form.get('client_id').disable();
    } else {
      this.jobs_expense_form.get('client_id').enable();
    }

    if (!this.label) {
      const currentUrl = this.router.url;
      if (currentUrl.includes('clients')) {
        this.jobs_expense_form.get('client_id').disable();
      } else if (currentUrl.includes('jobs')) {
        this.jobs_expense_form.get('job_id').disable();
        this.jobs_expense_form.get('client_id').disable();
      }
    } else {
      this.jobs_expense_form.get('client_id').enable();
    }

    this.jobs_expense_form.valueChanges.subscribe(() => {
      if (this.jobs_expense_form.dirty) {
        this.isFormDirty = true;
      } else {
        this.isFormDirty = false;
      }
    });

    setTimeout(() => {
      if (this.form_mode == this.formMode.Edit) {
        this.getcostinfoDetails();
      }
    }, 500);
  }

  ClientChanged() {
    this.jobs_service.clientJob(this.jobs_expense_form.get('client_id').value).subscribe({
      next: (response: any) => {
        if (response.result === 1) {
          this.jobs_list = response.data;
          this.jobs_expense_form.get('job_id').setValue(this.job_id);
          this.appendArchivedJob(this.job_id, this.job_name);

          if (this.label) {
            this.jobs_expense_form.get('job_id').setValue(this.job_id);
          }
        } else if (response.result === 0) {
          this.toaster_service.showError(response.error.message[0]);
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error);
      },
      complete: () => { }
    });

  }

  loadClients() {
    const pagination: any = {
      page: this.current_page,
      limit: this.storage_service.getLimit(true)
    }

    this.ddl_service.getClientDdl(pagination).subscribe({
      next: (response: clientDdlResponseModel) => {
        if (response.result === 1) {
          this.client_list = response.data;
          this.jobs_expense_form.get('client_id').setValue(this.client_id);
          if (!this.label) {
            this.appendArchivedClient(this.client_id, this.client_name);
          }
          this.ClientChanged();
        } else if (response.result === 0) {
          this.toaster_service.showError(response.error.message[0]);
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error);
      },
      complete: () => { }
    });
  }

  loadstaff_Ddl() {
    const pagination: any = {
      page: this.current_page,
      limit: this.storage_service.getLimit(true)
    }
    if (this.label || this.url.includes('clients')) {
      this.collaborationddl_service.getstaff_ddl(pagination).subscribe({
        next: (response: userprofileDdlResponseModel) => {
          if (response.result === 1) {
            this.user_list = response.data;
            const staff_id = this.storage_service.getUserId();
            this.jobs_expense_form.get('staff_id').setValue(staff_id)
          } else if (response.result === 0) {
            this.toaster_service.showError(response.error.message[0]);
          } else {
            this.toaster_service.showError(response.stackTrace);
          }
        },
        error: (error: any) => { },
        complete: () => { }
      });
    } else {
      this.collaborationddl_service.getStaffDdl(this.job_id, pagination).subscribe({
        next: (response: jobsStaffDdlResponseModel) => {
          if (response.result === 1) {
            this.user_list = response.data;
            const staff_id = this.storage_service.getUserId();
            this.jobs_expense_form.get('staff_id').setValue(staff_id)
          } else if (response.result === 0) {
            this.toaster_service.showError(response.error.message[0]);
          } else {
            this.toaster_service.showError(response.stackTrace);
          }
        },
        error: (error: any) => { },
        complete: () => { }
      });
    }
  }

  loadcostlist() {
    this.jobs_service.getCostDdl(this.current_page, this.items_per_page).subscribe({
      next: (response: costddls) => {
        if (response.result == 1) {
          this.cost_list = response.data;
        } else if (response.result == 0) {
          if (response.error.message) {
            this.toaster_service.showError(response.error.message[0])
          }
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.spinner_service.hide();
        this.toaster_service.showError(error);
      },
      complete: () => {
        this.spinner_service.hide();
      }
    });
  }

  onCancel(data: any) {
    const close = () => {
      if (this.label) {
        this.jobs_expense_form.reset();
        this.jobs_expense_form["submitted"] = false;
        this.onClose.emit(true);
      } else {
        this.ref.close(data);
      }
    };

    if (this.isFormDirty) {
      this.confirm_service
        .showConfirmation(this.translate_service.getText('info_40'))
        .then((result) => {
          if (result) close();
        });
    } else {
      close();
    }
  }


  onSave() {
    this.jobs_expense_form["submitted"] = true;
    this.job_cost_request = this.jobs_expense_form.getRawValue();
    this.job_cost_request.quantity = parseInt(this.jobs_expense_form.get('quantity').value, 10);
    this.job_cost_request.unit_cost = parseFloat(this.jobs_expense_form.get('unit_cost').value);
    this.job_cost_request.unit_price = parseFloat(this.jobs_expense_form.get('unit_price').value);
    this.jobs_expense_form.value.date = this.shared_service.formatDateToDB(this.jobs_expense_form.value.date);

    if (!this.jobs_expense_form.valid) {
      this.findFirstInvalidControl();
      return;
    }

    if (this.form_mode === this.formMode.Create) {
      this.jobs_service.createCost(this.job_cost_request).subscribe({
        next: (response: jobCostResponseModel) => {
          if (response.result == 1) {
            this.toaster_service.showSuccess(this.shared_service.account_cost_heading + ' ' + this.translate_service.getText('message_26'));
            this.jobs_expense_form.markAsPristine();
            if (this.jobs_expense_form.dirty) {
              this.isFormDirty = true;
            } else {
              this.isFormDirty = false;
            }
            this.onCancel(response.data);
          } else if (response.result == 0) {
            if (response.error.job_id) {
              this.error_message = response.error.job_id[0];
              this.jobs_expense_form.get('job_id')?.setErrors({ incorrect: true });
            }
            if (response.error.quantity) {
              this.error_message = response.error.quantity[0];
              this.jobs_expense_form.get('quantity')?.setErrors({ incorrect: true });
            }
            if (response.error.unit_cost) {
              this.error_message = response.error.unit_cost[0];
              this.jobs_expense_form.get('unit_cost')?.setErrors({ incorrect: true });
            }
            if (response.error.unit_price) {
              this.error_message = response.error.unit_price[0];
              this.jobs_expense_form.get('unit_price')?.setErrors({ incorrect: true });
            }
            if (response.error.cost_sell_type_id) {
              this.error_message = response.error.cost_sell_type_id[0];
              this.jobs_expense_form.get('cost_sell_type_id')?.setErrors({ incorrect: true });
            }
            if (response.error.is_billable) {
              this.error_message = response.error.is_billable[0];
              this.jobs_expense_form.get('is_billable')?.setErrors({ incorrect: true });
            }
            if (response.error.description) {
              this.error_message = response.error.description[0];
              this.jobs_expense_form.get('description')?.setErrors({ incorrect: true });
            }
            if (response.error.code) {
              this.error_message = response.error.code[0];
              this.jobs_expense_form.get('code')?.setErrors({ incorrect: true });
            }
            if (response.error.staff_id) {
              this.error_message = response.error.staff_id[0];
              this.jobs_expense_form.get('staff_id')?.setErrors({ incorrect: true });
            }
            if (response.error.client_id) {
              this.error_message = response.error.client_id[0];
              this.jobs_expense_form.get('client_id')?.setErrors({ incorrect: true });
              this.toaster_service.showError(response.error.client_id[0]);
            }
            if (response.error.cost_id) {
              this.error_message = response.error.cost_id[0];
              this.jobs_expense_form.get('cost_id')?.setErrors({ incorrect: true });
            }
            if (response.error.message) {
              this.toaster_service.showError(response.error.message[0]);
            }
            setTimeout(() => this.findFirstInvalidControl(), 0);
          } else {
            this.toaster_service.showError(response.stackTrace);
          }
        },
        error: (error) => {
          this.spinner_service.hide();
          this.toaster_service.showError(error);
        },
        complete: () => {
          this.spinner_service.hide();
        }
      });
    } else {
      this.job_cost_request = this.jobs_expense_form.getRawValue();
      this.job_cost_request.quantity = parseInt(this.jobs_expense_form.get('quantity').value, 10);
      this.job_cost_request.unit_cost = parseFloat(this.jobs_expense_form.get('unit_cost').value);
      this.job_cost_request.unit_price = parseFloat(this.jobs_expense_form.get('unit_price').value);
      this.jobs_service.updateCost(this.job_cost_id, this.job_cost_request).subscribe({
        next: (response: jobCostResponseModel) => {
          if (response.result == 1) {
            this.jobs_expense_form.markAsPristine();
            if (this.jobs_expense_form.dirty) {
              this.isFormDirty = true;
            } else {
              this.isFormDirty = false;
            }
            this.onCancel(response.data);
            this.toaster_service.showSuccess(this.shared_service.account_cost_heading + ' ' + this.translate_service.getText('message_27'));
          } else if (response.result == 0) {
            if (response.error.job_id) {
              this.error_message = response.error.job_id[0];
              this.jobs_expense_form.get('job_id')?.setErrors({ incorrect: true });
            }
            if (response.error.quantity) {
              this.error_message = response.error.quantity[0];
              this.jobs_expense_form.get('quantity')?.setErrors({ incorrect: true });
            }
            if (response.error.unit_cost) {
              this.error_message = response.error.unit_cost[0];
              this.jobs_expense_form.get('unit_cost')?.setErrors({ incorrect: true });
            }
            if (response.error.unit_price) {
              this.error_message = response.error.unit_price[0];
              this.jobs_expense_form.get('unit_price')?.setErrors({ incorrect: true });
            }
            if (response.error.cost_sell_type_id) {
              this.error_message = response.error.cost_sell_type_id[0];
              this.jobs_expense_form.get('cost_sell_type_id')?.setErrors({ incorrect: true });
            }
            if (response.error.is_billable) {
              this.error_message = response.error.is_billable[0];
              this.jobs_expense_form.get('is_billable')?.setErrors({ incorrect: true });
            }
            if (response.error.description) {
              this.error_message = response.error.description[0];
              this.jobs_expense_form.get('description')?.setErrors({ incorrect: true });
            }
            if (response.error.code) {
              this.error_message = response.error.code[0];
              this.jobs_expense_form.get('code')?.setErrors({ incorrect: true });
            }
            if (response.error.staff_id) {
              this.error_message = response.error.staff_id[0];
              this.jobs_expense_form.get('staff_id')?.setErrors({ incorrect: true });
            }
            if (response.error.client_id) {
              this.error_message = response.error.client_id[0];
              this.jobs_expense_form.get('client_id')?.setErrors({ incorrect: true });
              this.toaster_service.showError(response.error.client_id[0]);
            }
            if (response.error.cost_id) {
              this.error_message = response.error.cost_id[0];
              this.jobs_expense_form.get('cost_id')?.setErrors({ incorrect: true });
            }
            if (response.error.message) {
              this.toaster_service.showError(response.error.message[0]);
            }
            setTimeout(() => this.findFirstInvalidControl(), 0);
          } else {
            this.toaster_service.showError(response.stackTrace);
          }
        },
        error: (error) => {
          this.spinner_service.hide();
          this.toaster_service.showError(error);
        },
        complete: () => {
          this.spinner_service.hide();
        }
      });
    }
  }

  getcostinfoDetails() {
    this.jobs_service.getcost(this.job_cost_id).subscribe({
      next: (response: any) => {
        if (response.result == 1) {
          this.cost_details = response.data;
          this.job_id = response?.data?.job_id;
          this.job_name = response?.data?.job_name;

          // this.ClientChanged().subscribe(() => {
          this.jobs_expense_form.patchValue({
            cost_id: response.data.cost_id,
            date: response.data.date ? new Date(response.data.date) : this.selectedStartDate,
            unit_cost: response.data.unit_cost,
            unit_price: response.data.unit_price,
            quantity: response.data.quantity,
            code: response.data.code,
            is_billable: response.data.is_billable,
            description: response.data.description,
            is_actual: response.data.is_actual,
            cost_sell_type_id: response.data.cost_sell_type_id,
            staff_id: response.data.staff_id,
            job_id: response.data.job_id
          });
          this.appendArchivedExpense(response.data.cost_id, response.data.cost_name);
          // });


        } else if (response.result == 0) {
          if (response.error.message) {
            this.toaster_service.showError(response.error.message[0])
          }
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.spinner_service.hide();
        this.toaster_service.showError(error);
      },
      complete: () => {
        this.spinner_service.hide();
      }
    });
  }

  private findFirstInvalidControl(): void {
    const invalidControl = document.querySelector('.ng-invalid:not(form)') as HTMLElement;
    if (invalidControl) {
      invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      invalidControl.focus();
    }
  }

  costChange() {
    const cost_id = this.jobs_expense_form.get('cost_id').value;
    this.expense_service.getCostDetails(cost_id).subscribe({
      next: (response: costResponseModel) => {
        if (response.result == 1) {
          this.jobs_expense_form.patchValue({
            is_billable: response.data.is_billable,
            unit_cost: response.data.unit_cost,
            description: response.data.description,
            supplier_id: null,
            code: response.data.code,
            tax2_id: response.data.tax2_id_on_invoice_quote,
            tax1_id: response.data.tax1_id_on_invoice_quote,
            unit_price: response.data.unit_price,
            cost_sell_type_id: response.data.cost_sell_type_id,
          })
        } else if (response.result == 0) {
          if (response.error.message) {
            this.toaster_service.showError(response.error.message[0])
          }
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error);
      },
      complete: () => {
      }
    });
  }

  onDeletecost() {
    if (this.cost_details?.is_invoiced) {
      this.confirm_service.showWarning('cost could not be deleted because there are invoiced.').then((result) => {
        if (result.valueOf()) { }
      });
      return;
    }

    this.confirm_service.showConfirmation(this.translate_service.getText('Are you sure to delete this cost?')).then((result) => {
      if (result) {
        this.spinner_service.show();
        const data = {
          is_deleted: true
        }

        this.jobs_service.deletecost(this.job_cost_id, data).subscribe({
          next: (response: any) => {
            this.spinner_service.hide();
            if (response.result == 1) {
              this.toaster_service.showSuccess(this.translate_service.getText('message_192'));
              this.onCancel(response.data)
            } else if (response.result == 0) {
              if (response.error.message) {
                this.toaster_service.showError(response.error.message[0])
              }
            }
          },
          error: (error: any) => {
            this.spinner_service.hide();
            this.toaster_service.showError(error);
          },
          complete: () => {
            this.spinner_service.hide();
          }
        });
      }
    })
  }

  loadCostType() {
    this.spinner_service.show();
    this.org_ddl_service.getCostType().subscribe({
      next: (response: costTypeResponseModel) => {
        if (response.result == 1) {
          this.cost_type_list = response.data;
          const currentValue = this.jobs_expense_form.get('cost_sell_type_id')?.value;
          if (!currentValue && this.shared_service.default_cost_type_id) {
            this.jobs_expense_form.patchValue({
              cost_sell_type_id: this.shared_service.default_cost_type_id
            });
          }
        } else if (response.result == 0) {
          this.toaster_service.showError(response.error.message[0]);
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error) => {
        this.spinner_service.hide();
        this.toaster_service.showError(error);
      },
      complete: () => {
        this.spinner_service.hide();
      }
    })
  }

  appendArchivedClient(client_id: string, client_name: string) {
    const isExists = this.client_list.find((client: any) => client?.client_id === client_id);
    let clientDetail = {
      client_id: client_id,
      name: client_name
    }
    if (!isExists) {
      this.client_list.push(clientDetail);
    }
  }

  appendArchivedExpense(cost_id: string, cost_name: string) {
    const isExists = this.cost_list.find((client: any) => client?.cost_id === cost_id);
    let clientDetail = {
      cost_id: cost_id,
      name: cost_name
    }
    if (!isExists) {
      this.cost_list.push(clientDetail);
    }
  }

  appendArchivedJob(id: string, name: string) {
    if (id && name) {
      const isExists = this.jobs_list.find((task: any) => task?.job_task_id === id);
      let jobDetail = {
        job_id: id,
        name: name
      }
      if (!isExists) {
        this.jobs_list.push(jobDetail);
      }
    }
  }

  confirmDiscardChanges(): Promise<boolean> {
    return this.confirm_service.showConfirmation(
      this.translate_service.getText('info_40')
    );
  }
}
